import { apiConstants } from "../config";
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), "")}.home`,
                    text: "home.title",
                    icon: "fas fa-home"
                },
                acl: {
                    view: "GU_00001"
                }
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: `settings.titles`,
                    icon: "fas fa-cogs"
                },
                acl: {
                    view: "GU_00067",
                    edit: "GU_00068"
                },
                url: {
                    getConfig: `/${codeAPI}/gestao/definitions`
                }
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: "default_layers.titles",
                    icon: "fas fa-layer-group"
                },
                acl: {
                    view: "GU_00120",
                    detail: "GU_00121",
                    add: "GU_00122",
                    edit: "GU_00123",
                    delete: "GU_00124"
                },
                url: {
                    getList: `${codeAPI}/gestao/defaultlayers`,
                    getShow: `${codeAPI}/gestao/defaultlayers/:id`,
                    getCreate: `${codeAPI}/gestao/defaultlayers`,
                    getUpdate: `${codeAPI}/gestao/defaultlayers/:id`,
                    getDelete: `${codeAPI}/gestao/defaultlayers/:id`,
                    getLists: `${codeAPI}/gestao/defaultlayers/lists`,
                    getResources: `${codeAPI}/gestao/defaultlayers/resources`,
                }
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: `layers.titles`,
                    icon: "fas fa-layer-group"
                },
                acl: {
                    view: "GU_00006",
                    detail: "GU_00005",
                    add: "GU_00003",
                    edit: "GU_00004",
                    delete: "GU_00007",
                    private: "GU_00006" // ????
                },
                url: {
                    getList: `${codeAPI}/gestao/layers`,
                    getShow: `${codeAPI}/gestao/layers/:id`,
                    getCreate: `${codeAPI}/gestao/layers`,
                    getUpdate: `${codeAPI}/gestao/layers/:id`,
                    getDelete: `${codeAPI}/gestao/layers/:id`,
                    getLists: `${codeAPI}/gestao/layers/lists`,
                    getResources: `${codeAPI}/gestao/layers/resources`,
                    describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                }
            },
            regulations: {
                menu: {
                    route: `${code}.regulations`,
                    text: `regulations.titles`,
                    icon: "fas fa-book"
                },
                panel: {
                    files: {
                        maxFiles: 1,
                        mimeTypes: [
                            "application/msword",
                            "application/vnd.ms-excel",
                            "application/vnd.ms-powerpoint",
                            "application/pdf",
                            "text/plain",
                            "image/*",
                        ],
                    }
                },
                acl: {
                    view: "GU_00072",
                    detail: "GU_00071",
                    add: "GU_00069",
                    edit: "GU_00070",
                    delete: "GU_00073"
                },
                url: {
                    getList: `${codeAPI}/gestao/regulations`,
                    getShow: `${codeAPI}/gestao/regulations/:id`,
                    getCreate: `${codeAPI}/gestao/regulations`,
                    getUpdate: `${codeAPI}/gestao/regulations/:id`,
                    getDelete: `${codeAPI}/gestao/regulations/:id`,
                    getLists: `${codeAPI}/gestao/regulations/lists`
                }
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: `print_visible_emissions.titles`,
                    icon: "fas fa-print"
                },
                acl: {
                    view: "GU_00065",
                    config: "GU_00065",
                    configEdit: "GU_00066"
                },
                url: {
                    getList: `/${codeAPI}/gestao/printvisible`,
                    getConfig: `/${codeAPI}/gestao/printvisible/settings`,
                    getApps: `/${codeAPI}/gestao/printvisible/print/apps`
                }
            },
            classification_types: {
                menu: {
                    route: `${code}.classification_types`,
                    text: `classification_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00011",
                    detail: "GU_00010",
                    add: "GU_00008",
                    edit: "GU_00009",
                    delete: "GU_00012"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/classificationtypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/classificationtypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/classificationtypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/classificationtypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/classificationtypes/:id`
                }
            },
            construction_types: {
                menu: {
                    route: `${code}.construction_types`,
                    text: `construction_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00016",
                    detail: "GU_00015",
                    add: "GU_00013",
                    edit: "GU_00014",
                    delete: "GU_00017"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/constructiontypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/constructiontypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/constructiontypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/constructiontypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/constructiontypes/:id`
                }
            },
            order_types: {
                menu: {
                    route: `${code}.order_types`,
                    text: `order_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00021",
                    detail: "GU_00020",
                    add: "GU_00018",
                    edit: "GU_00019",
                    delete: "GU_00022"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/ordertypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/ordertypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/ordertypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/ordertypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/ordertypes/:id`
                }
            },
            procedure_types: {
                menu: {
                    route: `${code}.procedure_types`,
                    text: `procedure_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00026",
                    detail: "GU_00025",
                    add: "GU_00023",
                    edit: "GU_00024",
                    delete: "GU_00027"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/proceduretypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/proceduretypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/proceduretypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/proceduretypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/proceduretypes/:id`
                }
            },
            regime_types: {
                menu: {
                    route: `${code}.regime_types`,
                    text: `regime_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00031",
                    detail: "GU_00030",
                    add: "GU_00028",
                    edit: "GU_00029",
                    delete: "GU_00032"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/regimetypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/regimetypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/regimetypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/regimetypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/regimetypes/:id`
                }
            },
            limit_types: {
                menu: {
                    route: `${code}.limit_types`,
                    text: `limit_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00036",
                    detail: "GU_00035",
                    add: "GU_00033",
                    edit: "GU_00034",
                    delete: "GU_00037",
                    config: "GU_00086",
                    configEdit: "GU_00085"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/limittypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/limittypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/limittypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/limittypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/limittypes/:id`,
                    getConfig: `${codeAPI}/gestao/urbanplanning/limittypes/settings`
                }
            },
            use_types: {
                menu: {
                    route: `${code}.use_types`,
                    text: `use_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00041",
                    detail: "GU_00040",
                    add: "GU_00038",
                    edit: "GU_00039",
                    delete: "GU_00042"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/usetypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/usetypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/usetypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/usetypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/usetypes/:id`
                }
            },
            statuses: {
                menu: {
                    route: `${code}.statuses`,
                    text: `statuses.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00046",
                    detail: "GU_00045",
                    add: "GU_00043",
                    edit: "GU_00044",
                    delete: "GU_00047"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/statuses`,
                    getShow: `${codeAPI}/gestao/urbanplanning/statuses/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/statuses`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/statuses/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/statuses/:id`
                }
            },
            states: {
                menu: {
                    route: `${code}.states`,
                    text: `states.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00051",
                    detail: "GU_00050",
                    add: "GU_00048",
                    edit: "GU_00049",
                    delete: "GU_00052"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/states`,
                    getShow: `${codeAPI}/gestao/urbanplanning/states/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/states`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/states/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/states/:id`
                }
            },
            source_types: {
                menu: {
                    route: `${code}.source_types`,
                    text: `source_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00090",
                    detail: "GU_00089",
                    add: "GU_00087",
                    edit: "GU_00088",
                    delete: "GU_00091"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/sourcetypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/sourcetypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/sourcetypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/sourcetypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/sourcetypes/:id`
                }
            },
            document_types: {
                menu: {
                    route: `${code}.document_types`,
                    text: `document_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00117",
                    detail: "GU_00116",
                    add: "GU_00114",
                    edit: "GU_00115",
                    delete: "GU_00118"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/documenttypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/documenttypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/documenttypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/documenttypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/documenttypes/:id`
                }
            },
            entities: {
                menu: {
                    route: `${code}.entities`,
                    text: `entities.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00056",
                    detail: "GU_00055",
                    add: "GU_00053",
                    edit: "GU_00054",
                    delete: "GU_00057"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/entities`,
                    getShow: `${codeAPI}/gestao/urbanplanning/entities/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/entities`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/entities/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/entities/:id`
                }
            },
            confrontations: {
                menu: {
                    route: `${code}.confrontations`,
                    text: `confrontations.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00061",
                    detail: "GU_00060",
                    add: "GU_00058",
                    edit: "GU_00059",
                    delete: "GU_00062",
                    config: "GU_00064",
                    configEdit: "GU_00063"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/confrontations`,
                    getShow: `${codeAPI}/gestao/urbanplanning/confrontations/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/confrontations`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/confrontations/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/confrontations/:id`,
                    getLists: `${codeAPI}/gestao/urbanplanning/confrontations/lists`,
                    getConfig: `${codeAPI}/gestao/urbanplanning/confrontations/settings`,
                    getScales: `${codeAPI}/gestao/urbanplanning/confrontations/scales`,
                    getLayouts: `${codeAPI}/gestao/urbanplanning/confrontations/print/layouts/:appid`,
                    getFormats: `${codeAPI}/gestao/urbanplanning/confrontations/print/formats/:appid`,
                    getApps: `${codeAPI}/gestao/urbanplanning/confrontations/print/apps`,
                    getResources: `/backoffice/gestao/ogc/remoteservices/resources`
                }
            },
            matrix_classification_types: {
                menu: {
                    route: `${code}.matrix_classification_types`,
                    text: `matrix_classification_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00056",
                    detail: "GU_0055",
                    add: "GU_00053",
                    edit: "GU_00054",
                    delete: "GU_00057"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/matrixclassificationtypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/matrixclassificationtypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/matrixclassificationtypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/matrixclassificationtypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/matrixclassificationtypes/:id`
                }
            },
            license_types: {
                menu: {
                    route: `${code}.license_types`,
                    text: `license_types.titles`,
                    icon: "fas fa-list"
                },
                acl: {
                    view: "GU_00135",
                    detail: "GU_00134",
                    add: "GU_00132",
                    edit: "GU_00133",
                    delete: "GU_00136"
                },
                url: {
                    getList: `${codeAPI}/gestao/urbanplanning/licensetypes`,
                    getShow: `${codeAPI}/gestao/urbanplanning/licensetypes/:id`,
                    getCreate: `${codeAPI}/gestao/urbanplanning/licensetypes`,
                    getUpdate: `${codeAPI}/gestao/urbanplanning/licensetypes/:id`,
                    getDelete: `${codeAPI}/gestao/urbanplanning/licensetypes/:id`
                }
            }
        },
        tools: {}
    }
};

export default state;
